var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "powerbar-nav-events-panel" },
    [
      _vm._l(_vm.items, function(item) {
        return [
          _c(
            "li",
            {
              key: item.caption,
              staticClass: "powerbar-nav-events-panel__item"
            },
            [
              _c(
                "a",
                {
                  staticClass: "powerbar-nav-events-panel__link",
                  class: _vm.additionalClassesForItem(item),
                  attrs: {
                    href: item.actionUrl,
                    target: item.window === "newWindow" ? "_blank" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigateAction($event, item)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(item.caption) +
                      "\n            "
                  )
                ]
              )
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }